export enum CustomMarkerTypes {
  ACTIVE_STOP = 'ACTIVE_STOP',
  INACTIVE_STOP = 'INACTIVE_STOP',
  STOP_TYPE_HUB = 'STOP_TYPE_HUB',
  STOP_TYPE_IN_FIELD_BREAK = 'STOP_TYPE_IN_FIELD_BREAK',
  ROUTING_LOCATION = 'ROUTING_LOCATION',
  CUSTOMER_DISPLAY_LOCATION = 'CUSTOMER_DISPLAY_LOCATION',
}
